import React from "react";
import { Link, useLocation } from "react-router-dom";
import { theme } from "../../theme";

const Shell = ({ children }) => {
  const location = useLocation();

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: theme.colors.background,
      fontFamily: theme.fonts.body,
      color: theme.colors.navyText,
      display: "flex",
      flexDirection: "column",
    },
    header: {
      backgroundColor: theme.colors.white,
      borderBottom: `1px solid ${theme.colors.lines}`,
      padding: "0 2rem",
      height: "64px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      position: "sticky",
      top: 0,
      zIndex: 1000,
    },
    logo: {
      fontSize: "1.25rem",
      fontWeight: "bold",
      color: theme.colors.primaryBlue,
      textDecoration: "none",
    },
    navLinks: {
      display: "flex",
      gap: "2rem",
    },
    link: (isActive) => ({
      textDecoration: "none",
      color: isActive ? theme.colors.primaryBlue : theme.colors.navyText,
      fontWeight: isActive ? "600" : "400",
      fontSize: "0.95rem",
      padding: "0.5rem 0",
      borderBottom: isActive
        ? `2px solid ${theme.colors.primaryBlue}`
        : "2px solid transparent",
      transition: "all 0.2s ease",
    }),
    main: {
      flex: 1,
      width: "100%",
      maxWidth: "1200px",
      margin: "0 auto",
      padding: theme.spacing.pagePad,
    },
    footer: {
      backgroundColor: theme.colors.navyText,
      color: theme.colors.white,
      padding: "2rem",
      textAlign: "center",
      fontSize: "0.875rem",
      marginTop: "auto",
    },
  };

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Sales Onboarding", path: "/sales-onboarding" },
    { label: "Product Education", path: "/product-education" },
    { label: "The Blueprint", path: "/design-intent" }, // Added new link here
  ];

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <Link to="/" style={styles.logo}>
          Enablement Playbooks
        </Link>
        <nav style={styles.navLinks}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={styles.link(location.pathname === item.path)}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </header>

      {/* Main Content Injection */}
      <main style={styles.main}>{children}</main>

      {/* Footer */}
      <footer style={styles.footer}>
        &copy; {new Date().getFullYear()} Enablement Team. Internal Use Only.
      </footer>
    </div>
  );
};

export default Shell;
